export const PRODUCT_TYPES = {
    COMMODITY: 1,
    SERVICE: 2,
};

export default {
    PRODUCT_TYPES,
};
